const STASH_ATTRIBUTE = "data-row-field-name";

// Include or exclude one row of a bulk `foo[][bar]` form from submission, by moving its inputs'
// `name` to a stash attribute and back. FormData skips unnamed controls.
//
// Why names rather than `disabled`: Materialize builds its wrapper around a `<select>` on page
// load and renders one that was disabled at init permanently un-openable, so a multiple-choice
// field could never be opened. Removing the name leaves every control fully interactive and
// visually untouched, and leaves the `disabled` the server puts on fixed fields as the only
// thing controlling those.
//
// A row must contribute either its FULL set of inputs or NONE. Rack groups `foo[][bar]`
// positionally, starting a new hash whenever a key repeats, so a row reduced to a partial set of
// keys merges into its neighbour and silently shifts every later row's values onto the wrong
// record. That is why callers pass the row, not individual inputs.
export default function (row, { submit } = {}) {
  row.querySelectorAll("input, select, textarea").forEach((input) => {
    if (submit) {
      const stashed = input.getAttribute(STASH_ATTRIBUTE);
      if (stashed === null) return;

      input.setAttribute("name", stashed);
      input.removeAttribute(STASH_ATTRIBUTE);
    } else {
      const name = input.getAttribute("name");
      if (name === null) return;

      input.setAttribute(STASH_ATTRIBUTE, name);
      input.removeAttribute("name");
    }
  });
}
